import { ReactComponent as CheckDefIcon } from "assets/images/icons/checkbox_default.svg";
import { ReactComponent as CheckFillIcon } from "assets/images/icons/checkbox_fiilled.svg";

import React, { useState } from "react";
import { Box, Checkbox, TableCell, TableRow, TextField, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const UserAccountTableRow = ({
  account,
  index,
  isSelected,
  onSelect,
  onChange,
}) => {
  const theme = useTheme();
  const [dirtyFields, setDirtyFields] = useState({
    username: false,
    password: false,
  });

  const isUsernameInvalid = dirtyFields.username && !account.username?.trim();
  const isPasswordInvalid = dirtyFields.password && !account.password?.trim();

  const textfieldSx = (isValid = true) => ({
    "& .MuiOutlinedInput-root": {
      borderRadius: theme.shape.customBorderRadius[1],
      height: "31px",
      backgroundColor: theme.palette.primary.white,
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? theme.palette.primary.borderGreyPrimary
          : theme.palette.primary.redPrimary,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? theme.palette.primary.mainHover
          : theme.palette.primary.redPrimary,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? theme.palette.primary.main
          : theme.palette.primary.redPrimary,
      },
    },
  });
  const cellSx = {
    verticalAlign: "top",
    paddingTop: "10px",
    paddingBottom: "10px",
  };
  const controlRowSx = {
    minHeight: "42px",
    display: "flex",
    alignItems: "center",
  };
  const errorTextSx = {
    color: theme.palette.primary.redPrimary,
    fontSize: "12px",
    lineHeight: "18px",
    marginTop: "3px",
  };

  return (
    <TableRow>
      <TableCell sx={{ ...cellSx, width: "48px" }}>
        <Box sx={controlRowSx}>
          <Checkbox
            icon={<CheckDefIcon width="25px" height="25px" />}
            checkedIcon={<CheckFillIcon width="25px" height="25px" />}
            checked={isSelected}
            onChange={() => onSelect(index)}
          />
        </Box>
      </TableCell>
      <TableCell sx={cellSx}>
        <Box sx={controlRowSx}>
          <TextField
            value={account.username}
            sx={textfieldSx(!isUsernameInvalid)}
            fullWidth
            onChange={(e) => onChange(index, "username", e.target.value)}
            onBlur={() => setDirtyFields((prev) => ({ ...prev, username: true }))}
          />
        </Box>
        {isUsernameInvalid && <Typography sx={errorTextSx}>Required</Typography>}
      </TableCell>
      <TableCell sx={cellSx}>
        <Box sx={controlRowSx}>
          <TextField
            value={account.password}
            sx={textfieldSx(!isPasswordInvalid)}
            fullWidth
            onChange={(e) => onChange(index, "password", e.target.value)}
            onBlur={() => setDirtyFields((prev) => ({ ...prev, password: true }))}
          />
        </Box>
        {isPasswordInvalid && <Typography sx={errorTextSx}>Required</Typography>}
      </TableCell>
      <TableCell sx={cellSx}>
        <Box sx={controlRowSx}>
          <TextField
            value={account.description}
            sx={textfieldSx(true)}
            fullWidth
            onChange={(e) => onChange(index, "description", e.target.value)}
          />
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default React.memo(UserAccountTableRow);
